import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";

const menuService = {};

menuService.getMenu = function () {
  return fetch({
    url: `${env.API_MSCSM}/api/menu/getMenu`,
    method: "get",
  });
};

export default menuService;
